import React, { useState } from "react";
import Modal from "react-modal";
import "../style/index.css";
import Loading from "../components/loading";
import Button from "../components/ui/button";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

const RejectPaymentModal = (props) => {
  const [reason, setReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  console.log(id, "id");

  const closeModal = () => {
    props.setshow(false);
    setReason("");
    setError("");
  };
  console.log(props.data, "data");

  const handleDecline = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");

      const response = await axios.post(
        `/v1/admin/finance/pay/update/status/${id}`,
        {
          status: "rejected",
          reason: reason.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );
    
      if (response?.data?.error) {
        const errorData = await response?.data;
        throw new Error(errorData.message || `HTTP error! status: ${response?.status}`);
      }

      closeModal();

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Payment rejected successfully!",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });

      navigate(-1);
    } catch (error) {
      console.error("Error rejecting payment request:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to accept payment",
        text:  error?.response?.data?.message ||
          error?.message || "An unexpected error occurred.",
        timer: 4000,
        showConfirmButton: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const customStyles = {
    content: {
      margin: "5% auto",
      overflow: "hidden",
      maxWidth: "400px",
      height: "380px",
      width: "85%",
      padding: "20px",
      borderRadius: "8px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  return (
    <Modal
      isOpen={props.show}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Decline Request Modal"
    >
      <div className="modal-content">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Reject Request</h2>
          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-gray-700"
            disabled={isLoading}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleDecline}>
          <div className="mb-4">
            <p className="mb-4 text-gray-700">
              Are you sure you want to reject this payment request{" "}
            </p>

            <div className="mb-4">
              <div className="text-[#667085] text-xs px-2 ">Leave a reason</div>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={4}
                className="w-full h-[80px] bg-[#ECEFF3] outline-none focus:ring-2 focus:ring-gray-100 px-3 py-2 rounded-md resize-none"
                placeholder="Please provide a reason for declining this request..."
                disabled={isLoading}
                required
              />
            </div>

            {error && (
              <div className="p-2 mb-4 text-xs text-red-700 bg-red-100 border border-red-400 rounded">
                {error}
              </div>
            )}
          </div>

          <Button
            type="submit"
            className="w-full mt-4 p-4 rounded-[10px] bg-[#EBE4FF] font-bold text-[#6F00FF] hover:bg-[#EBE4FF] hover:text-[#6F00FF] disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={isLoading || !reason.trim()}
          >
            {isLoading ? <Loading /> : "Reject request"}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default RejectPaymentModal;
